/**
 * Shared, model-free text helpers used across the display builder (char
 * counters and banned-word scanning). Provider-agnostic so any tool can
 * reuse them.
 */

/** Character count as Unicode code points ("a🌲b" = 3), matching ad-platform counting. */
export function charCount(text) {
  return [...text].length;
}

function escapeRegExp(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Case-insensitive, whole-word banned scan. Returns the first banned
 * word/phrase found, or null. "sale" does NOT match "wholesale".
 */
export function findBannedWord(text, banned) {
  for (const word of banned) {
    const trimmed = word.trim();
    if (!trimmed) continue;
    const pattern = new RegExp(`(^|[^\\p{L}\\p{N}])${escapeRegExp(trimmed)}($|[^\\p{L}\\p{N}])`, "iu");
    if (pattern.test(text)) return trimmed;
  }
  return null;
}